import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useBankApplicationDownloadDocument = (
  opportunityId: string | undefined,
  bankApplicationId: string | undefined,
  documentId: string | undefined
) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['downloadBankApplicationDocument', opportunityId, bankApplicationId, documentId],
    queryFn: () =>
      opportunitiesApi.downloadBankApplicationDocument(opportunityId!, bankApplicationId!, documentId!),
    staleTime: 1_800_000,
    enabled: false,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useBankApplicationDownloadDocument;
